import { Box, Divider } from '@chakra-ui/react';
import { useEventTracking } from 'hooks/useEventTracking';
import { useEffect } from 'react';
import { HeroSection } from './HeroSection/HeroSection';
import { LegalSections } from './LegalSections';
import { FaqSupportCta } from './FaqSupportCta';
import 'https://cdn.marmot-cloud.com/npm/hylid-bridge/2.10.0/index.js';

export const TermsOfUse = () => {
  const { eventTracking } = useEventTracking();
  useEffect(() => {
    eventTracking.page.viewed({
      pageName: 'terms_of_use_page',
      url: window.location.href,
    });
  }, [eventTracking]);
  return (
    <Box bg='white' minH='100vh' dir='rtl'>
      <HeroSection />
      <Box maxW='container.xl' mx='auto' px={{ base: '20px', md: '100px' }}>
        <Divider borderColor='#E8E5E2' borderWidth='1px' mt={0} mb={0} />
      </Box>
      <Box
        bg='white'
        py={{ base: '24px', md: '36px' }}
        px={{ base: '16px', md: '100px' }}
        maxW='container.xl'
        mx='auto'
      >
        <LegalSections />
      </Box>
      <FaqSupportCta />
    </Box>
  );
};
